import { DateRange } from "@mui/icons-material";
import { Button, FormGroup, FormLabel, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import SideSheetFilterInput from "../side-sheet/side-sheet-filter-input/SideSheetFilterInput";
import SideSheetSwitch from "../side-sheet/side-sheet-switch/SideSheetSwitch";
import { useObjectHistoryContext } from "./ObjectHistoryContext";

export type ObjectHistoryOptionsProps = {
    noAlarms?: boolean;
    noDiagnosticEvents?: boolean;
    noDataQualityEvents?: boolean;
    noFormEvents?: boolean;
    noManualEvents?: boolean;
    noMemos?: boolean;
    noSettingsChanges?: boolean;
    onShowDurationSettings?: () => void;
};

export default function ObjectHistoryOptions({
    noAlarms,
    noDiagnosticEvents,
    noDataQualityEvents,
    noFormEvents,
    noManualEvents,
    noMemos,
    noSettingsChanges,
    onShowDurationSettings
}: ObjectHistoryOptionsProps) {
    const { t } = useTranslation();

    const {
        state: {
            filterText,
            showMemos,
            showSettingsChanges,
            showAlarms,
            showDiagnosticEvents,
            showDataQualityEvents,
            showFormEvents,
            showManualEvents,
            durationLabel
        },
        setFilterText,
        setShowMemos,
        setShowSettingsChanges,
        setShowAlarms,
        setShowDiagnosticEvents,
        setShowDataQualityEvents,
        setShowFormEvents,
        setShowManualEvents,
    } = useObjectHistoryContext();

    return (
        <Stack spacing={2}>
            <SideSheetFilterInput
                label="Filter Text"
                value={filterText}
                onChange={(value) => {
                    setFilterText(value);
                }}
            />

            <FormGroup>
                <FormLabel>Include in List</FormLabel>
                {(noMemos !== true) &&
                    <SideSheetSwitch
                        label={t("objectHistoryFilter.memos")}
                        checked={showMemos}
                        onChange={(checked) => {
                            setShowMemos(checked);
                        }}
                    />
                }

                {(noSettingsChanges !== true) &&
                    <SideSheetSwitch
                        label={t("objectHistoryFilter.settingsChange")}
                        checked={showSettingsChanges}
                        onChange={(checked) => {
                            setShowSettingsChanges(checked);
                        }}
                    />
                }

                {(noAlarms !== true) &&
                    <SideSheetSwitch
                        label={t("objectHistoryFilter.alarms")}
                        checked={showAlarms}
                        onChange={(checked) => {
                            setShowAlarms(checked);
                        }}
                    />
                }

                {(noDiagnosticEvents !== true) &&
                    <SideSheetSwitch
                        label={t("objectHistoryFilter.diagnosticEvents")}
                        checked={showDiagnosticEvents}
                        onChange={(checked) => {
                            setShowDiagnosticEvents(checked);
                        }}
                    />
                }

                {(noDataQualityEvents !== true) &&
                    <SideSheetSwitch
                        label={t("objectHistoryFilter.dataQualityEvents")}
                        checked={showDataQualityEvents}
                        onChange={(checked) => {
                            setShowDataQualityEvents(checked);
                        }}
                    />
                }

                {(noFormEvents !== true) &&
                    <SideSheetSwitch
                        label={t("objectHistoryFilter.formEvents")}
                        checked={showFormEvents}
                        onChange={(checked) => {
                            setShowFormEvents(checked);
                        }}
                    />
                }

                {(noManualEvents !== true) &&
                    <SideSheetSwitch
                        label={t("objectHistoryFilter.manualEvents")}
                        checked={showManualEvents}
                        onChange={(checked) => {
                            setShowManualEvents(checked);
                        }}
                    />
                }

                <FormLabel component="legend">{t('customDuration.duration')}</FormLabel>
                <Button variant='text'
                    startIcon={<DateRange />}
                    sx={{ justifyContent: 'flex-start' }}
                    onClick={() =>
                        onShowDurationSettings && onShowDurationSettings()
                    }>
                    {durationLabel}
                </Button>
            </FormGroup>
        </Stack>
    );
}